export const socialLinks = [
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/jimena.marckyle',
    icon: 'fab fa-facebook',
    hoverColor: 'hover:text-blue-600'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/jimena.marckyle/',
    icon: 'fab fa-instagram',
    hoverColor: 'hover:text-pink-600'
  },
  {
    name: 'LinkedIn',
    url: 'https://www.linkedin.com/in/marc-kyle-jimena-35711338a/',
    icon: 'fab fa-linkedin',
    hoverColor: 'hover:text-blue-700'
  }
]
